import { useQuery } from '@apollo/client'
import { noop } from 'lodash'
import { TAKE_ALL_ITEMS_COUNT } from 'constants/consts'
import { FIND_ALL_SUCCESS_STORIES } from 'queries/successStory'
import { findAllSuccessStory, findAllSuccessStoryVariables } from '__generatedTypes__/findAllSuccessStory'
import { SelectItem } from './SimilarPosts'

const POSTS_COUNT = 3

type UseGetAllSuccessStoriesReturn = {
  loading: boolean
  getInitialValue: (selected: SelectItem[]) => SelectItem[]
}

export const getPostsValue = (selectedPosts: SelectItem[], totalPostsCount: number, selectedPostsCount: number) => {
  if (selectedPostsCount >= POSTS_COUNT || totalPostsCount < 0) {
    return selectedPosts
  }

  if (totalPostsCount >= POSTS_COUNT) {
    const additionalPosts = new Array(POSTS_COUNT - selectedPostsCount).fill(0).map(noop) as unknown as SelectItem[]
    return [...selectedPosts, ...additionalPosts]
  }

  const additionalPosts = new Array(totalPostsCount - selectedPostsCount).fill(0).map(noop) as unknown as SelectItem[]
  return [...selectedPosts, ...additionalPosts]
}

export const useGetSimilarPostsInitialValue = (
  platformId: string,
  isEditing = false
): UseGetAllSuccessStoriesReturn => {
  const { data, loading } = useQuery<findAllSuccessStory, findAllSuccessStoryVariables>(FIND_ALL_SUCCESS_STORIES, {
    variables: {
      query: {
        take: TAKE_ALL_ITEMS_COUNT,
        where: {
          platform: {
            id: platformId,
          },
        },
      },
    },
  })

  const successStories = data?.findAllSuccessStory?.items || []

  const getInitialValue = (selectedPosts: SelectItem[]) => {
    const successStoriesCount = successStories.length
    const selectedPostsLength = selectedPosts?.length || 0

    return getPostsValue(selectedPosts, isEditing ? successStoriesCount - 1 : successStoriesCount, selectedPostsLength)
  }

  return { loading, getInitialValue }
}
